import {
  UserPlusIcon,
  MegaphoneIcon,
  ArrowUpTrayIcon,
  WrenchScrewdriverIcon,
  UserGroupIcon,
  EyeSlashIcon,
  MapPinIcon,
  ClockIcon,
  DocumentTextIcon,
  PresentationChartLineIcon,
  ChartBarIcon,
} from "@heroicons/react/24/outline";
import { NavigationItem } from "./types";

const navigation: NavigationItem[] = [
  {
    name: "Reports",
    href: "#",
    icon: ChartBarIcon,
    current: false,
    internalName: "reports",
    // The Sales & Customer Dashboard moved to the Dashboards section — this
    // group now gates on the union of the reports still living here.
    permissions: [
      "stochastic-roi-dashboard",
      "stochastic-mp-dashboard",
      "stochastic-total-addressable-market",
    ],
    children: [
      {
        name: "ROI Dashboard",
        href: "/lead-generation/roi-dashboard",
        icon: PresentationChartLineIcon,
        current: false,
        internalName: "roi_dashboard",
        permissions: ["stochastic-roi-dashboard"],
      },
      {
        name: "Market Presence Dashboard",
        href: "/lead-generation/market-presence",
        icon: ChartBarIcon,
        current: false,
        internalName: "market_presence",
        permissions: ["stochastic-mp-dashboard"],
      },
      {
        name: "Total Addressable Market",
        href: "/lead-generation/total-addressable-market",
        icon: ChartBarIcon,
        current: false,
        internalName: "total_addressable_market",
        permissions: ["stochastic-total-addressable-market"],
      },
    ],
  },
  {
    name: "Prospects",
    href: "/lead-generation/prospects",
    icon: UserPlusIcon,
    current: false,
    internalName: "prospects",
    permissions: ["stochastic-prospects"],
  },
  {
    name: "Customers",
    href: "/lead-generation/customers",
    icon: UserGroupIcon,
    current: false,
    internalName: "customers",
    permissions: ["stochastic-customers"],
  },
  {
    name: "Invoices",
    href: "/lead-generation/invoices",
    icon: DocumentTextIcon,
    current: false,
    internalName: "invoices",
    permissions: ["stochastic-invoices"],
  },
  {
    name: "Locations",
    href: "/lead-generation/locations",
    icon: MapPinIcon,
    current: false,
    internalName: "locations",
    permissions: ["stochastic-locations"],
  },
  {
    name: "Campaign Management",
    href: "/lead-generation/campaigns",
    icon: MegaphoneIcon,
    current: false,
    internalName: "campaigns",
    permissions: ["stochastic-campaign-management"],
  },
  {
    name: "Uploads",
    href: "#",
    icon: ArrowUpTrayIcon,
    current: false,
    internalName: "uploads_group",
    permissions: ["stochastic-uploads"],
    children: [
      {
        name: "Field Service Import",
        href: "/lead-generation/field-service-import",
        icon: WrenchScrewdriverIcon,
        current: false,
        internalName: "field_service_import",
        permissions: ["stochastic-uploads"],
      },
      {
        name: "Prospect Source Import",
        href: "/lead-generation/prospect-source-import",
        icon: UserPlusIcon,
        current: false,
        internalName: "prospect_source_import",
        permissions: ["stochastic-uploads"],
      },
      {
        name: "Do Not Mail Import",
        href: "/lead-generation/do-not-mail-import",
        icon: EyeSlashIcon,
        current: false,
        internalName: "do_not_mail_import",
        permissions: ["stochastic-uploads"],
      },
      {
        name: "Import Status",
        href: "/lead-generation/import-status",
        icon: ClockIcon,
        current: false,
        internalName: "import_status",
        permissions: ["stochastic-uploads"],
      },
    ],
  },
];

const stochasticConfig = {
  sectionName: "stochastic",
  defaultRoute: "/lead-generation/roi-dashboard",
  navigation,
};

export default stochasticConfig;
